import React from "react";
import { observer } from "mobx-react";
import { TrendingStationListTemplate } from "themes/administration/analytics/pages";
import { TrendingStationListViewStore } from "administration/analytics/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new TrendingStationListViewStore(rootStore, componentProps),
    "trendingStationListViewStore"
)
@observer
class TrendingStationList extends React.Component {
    render() {
        return <TrendingStationListTemplate {...this.props} />;
    }
}

export default TrendingStationList;
